import {action, makeObservable, observable, toJS} from 'mobx'

import {MerchantService as Service} from 'rest/services/MerchantService'
import {MerchantQueueService} from 'rest/services/MerchantQueueService'
import {Stores} from './index'
import {MerchantAddDto} from 'rest/models/MerchantAddDto'
import {MerchantQueueAddDto} from 'rest/models/MerchantQueueAddDto'
import {MerchantQueueDto} from 'rest/models/MerchantQueueDto'

export class MerchantStore {
  stores: Stores
  _merchant: MerchantQueueDto

  constructor(stores: Stores) {
    this.stores = stores
    makeObservable(this, {
      _merchant: observable,
      getMerchantQueueGetByAdvertiserId: action,
      addMerchant: action,
    })
  }

  get merchant() {
    // if (localStorage.getItem('merchant') !== 'undefined') {
    //   this._merchant = JSON.parse(localStorage.getItem('merchant'))
    // }
    return toJS(this._merchant)
  }

  getMerchantQueueGetByAdvertiserId = async (): Promise<any> => {
    try {
      const res =
        await MerchantQueueService.getApiMerchantQueueGetByAdvertiserId(
          this.stores.AdvertiserStore.advertiser.id
        )
      if (res.data) {
        this._merchant = res.data.pop()
        // localStorage.setItem('merchant', JSON.stringify(this._merchant))
        return this._merchant
      } else return null
    } catch (err) {
      return this.stores.ErrorStore.handle(err)
    }
  }

  getMerchantQueueGetByMerchantId = async (
    merchantId: number
  ): Promise<any> => {
    try {
      const res: any =
        await MerchantQueueService.getApiMerchantQueueGetByMerchantId(
          merchantId
        )
      this._merchant = res.data
    } catch (err) {
      return this.stores.ErrorStore.handle(err)
    }
  }

  addMerchant = async (payload: MerchantAddDto) => {
    try {
      const res: any = await Service.postApiMerchantAdd(payload)
      await this.getMerchantQueueGetByMerchantId(res.data.id)
      this._merchant = {...res.data, merchantId: res.data.id}
      return this._merchant
    } catch (err) {
      return this.stores.ErrorStore.handle(err)
    }
  }

  queueMerchant = async (payload: MerchantQueueAddDto) =>
    await MerchantQueueService.postApiMerchantQueueAdd(payload)
      .then(res => {
        // this.getMerchantQueueGetByAdvertiserId()
        return res
      })
      .catch(err => this.stores.ErrorStore.handle(err))
}
